export default __webpack_public_path__ + "89195457bc1ff2f2183c1897157d0561.svg";